/* ============================================================================
   TOTH PERSONAL ADVISOR · JavaScript
   ============================================================================
   Vanilla, leve, sem dependências.
   Comportamento: reveal on scroll com delays escalonados.
   ============================================================================ */

(function () {
  'use strict';

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(section) {
    if (REDUCED || !('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    section.querySelectorAll('[data-pa-delay]').forEach((el) => {
      el.style.setProperty('--pa-anim-delay', el.dataset.paDelay + 'ms');
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            io.unobserve(section);
          }
        });
      },
      { threshold: 0.08 }
    );
    io.observe(section);
  }

  function init(root) {
    const r = root || document;
    const sections = r.querySelectorAll('[data-section-type="toth-personal-advisor"]');
    sections.forEach((section) => initReveal(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.dataset.sectionType === 'toth-personal-advisor') {
      init(e.target.parentElement);
    }
  });

  document.addEventListener('shopify:section:select', (e) => {
    if (e.target && e.target.dataset.sectionType === 'toth-personal-advisor') {
      e.target.classList.add('is-visible');
    }
  });
})();
